module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/define-property.js
// module id = 44
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/babel-runtime/core-js/object/define-property.js